import { useMutation, useQueryClient } from "@tanstack/react-query";
import { stergeTargetareCampanie } from "@/api/endpoints/targetareTinte";
import { queryKeys } from "@/lib/queryClient";

export function useStergeTargetareCampanie() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: stergeTargetareCampanie,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.tinte() });
    },
  });
}
